var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoAlert(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.4987 0.333984C3.82267 0.333984 0.832031 3.32463 0.832031 7.00065C0.832031 10.6767 3.82267 13.6673 7.4987 13.6673C11.1747 13.6673 14.1654 10.6767 14.1654 7.00065C14.1654 3.32463 11.1747 0.333984 7.4987 0.333984ZM7.9362 10.334H7.0612V5.70065H7.9362V10.334ZM7.4987 4.85065C7.1737 4.85065 6.90703 4.58398 6.90703 4.25898C6.90703 3.93399 7.1737 3.66732 7.4987 3.66732C7.83203 3.66732 8.09036 3.92565 8.09036 4.25898C8.09036 4.59232 7.83203 4.85065 7.4987 4.85065Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoAlert);
export default __webpack_public_path__ + "static/media/info-alert.e3d995610d17a4ea1129efa1ad1a2607.svg";
export { ForwardRef as ReactComponent };